module.exports = __webpack_public_path__ + "img/home_phone_banner2.861430e4.png";